<template>
  <main class="main customer_chat_list" role="main" v-if="isCompleted">
    <!-- <div class="chat_head">
      <div class="con_top">
        <h1 class="con_ttl">상담내역</h1>
        <button class="my_btn" @click="goMyPage"></button>
      </div>
    </div> -->
    <div class="main_con">
      <div ref="dummy"></div>
      <div class="con_banner">
        <div class="main_slide_2">
          <div>
            <Swiper :options="swiperOption" @click-slide="clickSlide">
              <SwiperSlide
                v-for="(item, index) in mainSlide"
                :key="index"
                class="slide_bnr_list pnt"
              >
                <div class="bnr">
                  <img
                    :src="require(`@/assets/front/images/${item.img}`)"
                    alt=""
                  />
                </div>
              </SwiperSlide>
              <div class="swiper-pagination" slot="pagination"></div>
            </Swiper>
          </div>
        </div>
      </div>
      <div class="chat_list" v-if="list.length > 0">
        <ul class="chat_list_ul">
          <chatRoomListItem
            v-for="chatroom in list"
            :key="chatroom.id"
            :chatroom="chatroom"
          />
        </ul>
      </div>
      <div class="list_view_tab">
        <ul>
          <li
            class="pnt"
            :class="{ on: chatListType == 'ALL' }"
            @click="listTabCli('ALL')"
          >
            전체
          </li>
          <li
            class="pnt"
            :class="{ on: chatListType == 'INTERNET' }"
            @click="listTabCli('INTERNET')"
          >
            인터넷
          </li>
          <li
            class="pnt"
            :class="{ on: chatListType == 'MOBILE' }"
            @click="listTabCli('MOBILE')"
          >
            휴대폰
          </li>
        </ul>
      </div>
      <div class="empty_wrap" v-if="fetchCompleted && list.length == 0">
        <div class="empty">
          <!--'기본: ', '준비중: ready', '결과없음: result'-->
          <div class="msg">
            <div>채팅 상담 내역이 없습니다.</div>
            <div>동네매장에서 상담을 받아 보세요.</div>
          </div>
        </div>
      </div>
      <infinite-loading
        ref="infiniteLoading"
        :direction="direction"
        :identifier="infiniteId"
        @infinite="infiniteHandler"
      >
        <span slot="no-more"></span>
        <span slot="no-results"></span>
        <span slot="spinner"> </span>
      </infinite-loading>
    </div>
    <NewBookModal ref="newBookModal" @close="closeNewBookModal"></NewBookModal>
  </main>
</template>

<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';

// Import Swiper styles
import 'swiper/swiper.scss';
import chatRoomListItem from './components/ChatRoomListItem.vue';
import {
  mapActions as commonMapActions,
  mapState as commonMapState,
  mapGetters as commonMapGetters,
} from '@common/store/modules/common';
import * as commonActions from '@common/store/modules/common/types';
import * as commonGetters from '@common/store/modules/common/getters';
import { mapActions, mapState, mapGetters } from '@common/store/modules/chat';
import * as actions from '@common/store/modules/chat/types';
import * as getters from '@common/store/modules/chat/getters';
import {
  mapActions as userMapActions,
  mapGetters as userMapGetters,
} from '@common/store/modules/user';
import * as userTypes from '@common/store/modules/user/types';

import { mapActions as bannerMapActions } from '@common/store/modules/banner';
import * as bannerTypes from '@common/store/modules/banner/types';

import * as util from '@common/lib/common/utils';
import NewBookModal from '@common/components/chat/modal/NewBookModal';
import InfiniteLoading from 'vue-infinite-loading';

import promotionCfg from '@common/lib/common/promotionCfg';

export default {
  components: {
    chatRoomListItem,
    Swiper,
    SwiperSlide,
    NewBookModal,
    InfiniteLoading,
  },
  data() {
    return {
      fetchCompleted: false,
      myDeviceName: '',
      myTelecomName: '',
      mainSlide: [
        {
          num: '0',
          linkType: 'link',
          telecom: 'HELLO',
          linkName: 'InternetCommerce.PromotionDetailHello',
          img: 'banner/main/img_promotion_bnr_internet_hello.png',
          params: {},
        },
        {
          num: '1',
          linkType: 'link',
          telecom: 'KT',
          linkName: 'InternetCommerce.PromotionDetailKt',
          img: 'banner/main/img_promotion_bnr_internet_kt.png',
          params: { isTab: 'tab_1', type: '100M' },
        },
        {
          num: '2',
          linkType: 'link',
          telecom: '',
          linkName: 'Manual.Main',
          img: 'banner/main/banner_coun_01.png',
          params: { isTab: 'tab_1' },
        },
        {
          num: '3',
          linkType: 'link',
          telecom: '',
          linkName: 'Manual.Main',
          img: 'banner/main/banner_coun_02.png',
          params: { isTab: 'tab_2' },
        },
        {
          num: '4',
          linkType: 'link',
          telecom: '',
          linkName: 'Shop.List',
          img: 'banner/main/banner_coun_03.png',
        },
      ],
      swiperOption: {
        // slidesPerView: 1,
        spaceBetween: 1,
        loop: true,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false, // 수동 슬라이드 후 일정시간이 지나면 다시 자동
        },
        speed: 500,
        pagination: {
          el: '.swiper-pagination',
        },
      },
      chatrooms: [],
      isCompleted: false,
      direction: 'top',
      infiniteId: 0,
      list: [],
      size: 10000,
      page: 1,
      chatListType: 'ALL',
      hideBlock: 'Y',
      hideLeave: 'Y',
      ktPromotionView: false,
      helloPromotionView: false,
    };
  },
  async created() {
    await this.getDevice();
    await this.fetchPromotionView();
    // await this.fetch();
    this.isCompleted = true;
    await this.setBnr();
    await this.updateChatMemberScreenActivedAll();

    await this.setPromotionBnrView('CHAT_MAIN_TOP', 'VIEW'); // 노출 확인
  },
  computed: {
    // ...mapGetters({
    //   chatrooms: getters.CHATROOMS,
    // }),
    ...userMapGetters({
      user: userTypes.USER,
    }),
  },
  // async beforeRouteEnter(to, from, next) {
  //   //await store.dispatch('user/USER_RESET_STATE');
  //   return next(async vm => {
  //     await vm.fetch();
  //     await vm.updateChatMemberScreenActivedAll();
  //   });
  // },
  async mounted() {
    this.infiniteId++;
  },
  methods: {
    ...bannerMapActions([bannerTypes.CLICK_VIEW_BANNER]),
    ...commonMapActions([commonActions.SET_DIALOG, commonActions.HIDE_DIALOG]),
    ...mapActions([
      actions.FETCH_CHATROOMS,
      actions.UPDATE_MEMBER_SCREEN_ACTIVED_ALL,
    ]),
    ...userMapActions([userTypes.UPDATE_USER_TELECOM_AND_DEVICE]),

    async fetch() {
      this.chatrooms = await this[actions.FETCH_CHATROOMS]({
        chatRoomType: 'OneOnOne',
        page: this.page,
        size: this.size,
        chatListType: this.chatListType,
        hideBlock: this.hideBlock,
        hideLeave: this.hideLeave,
      });
      console.log('chat_1');
      console.log(this.chatrooms);
      // console.log(ch);
    },
    async updateChatMemberScreenActivedAll() {
      console.log('chat_2');
      this[actions.UPDATE_MEMBER_SCREEN_ACTIVED_ALL]({
        actived: false,
      });
    },
    async getDevice() {
      util.nativeDeviceInfo();
      await util.sleep(800);
      this.myDeviceName = window.$bridge.deviceModelName || '';
      this.myTelecomName = window.$bridge.telecomName || '';

      // 로그인 후 디바이스 정보 저장
      // if (this.myDeviceName != '' || this.myTelecomName != '') {
      //   let td_param = {
      //     id: this.user.id,
      //     deviceModelName: this.myDeviceName,
      //     telecomName: this.myTelecomName,
      //   };
      //   this[userTypes.UPDATE_USER_TELECOM_DEVICE](td_param);
      // }

      if (this.myDeviceName != '' || this.myTelecomName != '') {
        let td_param = {
          id: this.user.id,
          deviceName: this.myDeviceName,
          deviceModelName: '',
          telecomName: this.myTelecomName,
        };
        this[userTypes.UPDATE_USER_TELECOM_AND_DEVICE](td_param);
      }
    },
    goList(link) {
      this.$router.push({
        name: link,
      });
    },
    goManual(name, params) {
      console.log('goManual');
      console.log(name);
      console.log(params);
      this.$router.push({
        name: name,
        params: params,
      });
    },
    goShopList(name) {
      this.$router.push({
        name: name,
      });
    },
    // swiper 안에 onclick 사용 하면 duplication 되어있는 영역은 onclick 가 안됨..ㅠㅠ  아래 방법으로 처리
    clickSlide(index, reallyIndex) {
      console.log('index : ' + index + ' : reallyIndex : ' + reallyIndex);

      let linkName = this.mainSlide[reallyIndex].linkName;
      let params = this.mainSlide[reallyIndex].params;

      if (linkName == 'InternetCommerce.PromotionDetailKt') {
        util.sdk_logEvent('INTERNET_PROMOTION_BANNER', {
          promotionCode: 'KT2408',
          user_id: this.user.id,
          user_nickname: this.user.nickname,
          telecom: 'KT',
          banner_position: 'CHAT_MAIN_TOP',
        });

        util.sdk_logEventKakao('INTERNET_PROMOTION_BANNER_CHAT');

        this.setPromotionBnrView('CHAT_MAIN_TOP', 'CLICK', 'KT');
      } else if (linkName == 'InternetCommerce.PromotionDetailHello') {
        util.sdk_logEvent('INTERNET_PROMOTION_BANNER', {
          promotionCode: 'HELLO',
          user_id: this.user.id,
          user_nickname: this.user.nickname,
          telecom: 'HELLO',
          banner_position: 'CHAT_MAIN_TOP',
        });

        util.sdk_logEventKakao('INTERNET_PROMOTION_BANNER_CHAT');

        this.setPromotionBnrView('CHAT_MAIN_TOP', 'CLICK', 'HELLO');
      }

      this.$router.push({
        name: linkName,
        params: params,
      });
      // if (this.promotionView) {
      //   if (reallyIndex == 0) {
      //     util.sdk_logEvent('INTERNET_PROMOTION_BANNER', {
      //       promotionCode: 'KT2408',
      //       user_id: this.user.id,
      //       user_nickname: this.user.nickname,
      //       telecom: 'KT',
      //       banner_position: 'CHAT_MAIN_TOP',
      //     });
      //     util.sdk_logEventKakao('INTERNET_PROMOTION_BANNER_CHAT');

      //     // 클릭 이벤트
      //     const params = {
      //       company: 'KT',
      //       campaign: 'PROMOTION',
      //       place: 'CHAT_MAIN_TOP',
      //       type: 'CLICK',
      //     };
      //     this[bannerTypes.CLICK_VIEW_BANNER](params);

      //     this.goPromotion(
      //       this.mainSlide[reallyIndex].link_name,
      //       this.mainSlide[reallyIndex].params,
      //     );
      //   } else if (reallyIndex == 1) {
      //     this.goManual(
      //       this.mainSlide[reallyIndex].link_name,
      //       this.mainSlide[reallyIndex].params,
      //     );
      //   } else if (reallyIndex == 2) {
      //     this.goManual(
      //       this.mainSlide[reallyIndex].link_name,
      //       this.mainSlide[reallyIndex].params,
      //     );
      //   } else if (reallyIndex == 3) {
      //     this.goShopList(this.mainSlide[reallyIndex].link_name);
      //   }
      // } else {
      //   if (reallyIndex == 0) {
      //     this.goManual(
      //       this.mainSlide[reallyIndex].link_name,
      //       this.mainSlide[reallyIndex].params,
      //     );
      //   } else if (reallyIndex == 1) {
      //     this.goManual(
      //       this.mainSlide[reallyIndex].link_name,
      //       this.mainSlide[reallyIndex].params,
      //     );
      //   } else if (reallyIndex == 2) {
      //     this.goShopList(this.mainSlide[reallyIndex].link_name);
      //   }
      // }
    },
    listTabCli(sel) {
      this.chatListType = sel;
      this.getListPageOne();
    },
    goMyPage() {
      this.$router.push({ name: 'MyPage.Main' });
    },
    // 사전예약 열기 (hsh)
    openNewBookModal() {
      this.$refs.newBookModal.isOpen = true;
      this.$refs.newBookModal.isSendButton = false;
    },
    closeNewBookModal() {
      this.$refs.newBookModal.isOpen = false;
    },
    async getListPageOne() {
      this.direction = 'top';
      this.page = 1;
      this.infiniteId += 1;
    },
    async infiniteHandler($state) {
      console.log(`infiniteId${this.infiniteId}`);
      console.log(this.chatrooms.content);
      if (this.infiniteId == 0) {
        $state.complete();
      } else {
        this.direction = 'bottom';
        await this.fetch();
        if (this.page == 1) {
          this.list = [];
        }
        if (this.chatrooms.content.length) {
          this.list.push(...this.chatrooms.content);
          if (this.page == 1) {
            setTimeout(() => {
              this.$refs.dummy.scrollIntoView({ behavior: 'auto' });
              //window.scrollTo(0, 0);
            }, 10);
          }
          this.page += 1;
          $state.loaded();
        } else {
          $state.complete();
        }
      }
      console.log('this.list');
      console.log(this.list);
      this.fetchCompleted = true;
    },
    noticeLink(id) {
      this.$router.push({
        name: 'Notice.Article',
        params: { id: id },
      });
    },
    async fetchPromotionView() {
      if (this.user.emdAreaName == null || this.user.emdAreaName == '') {
        console.log(1);
      } else {
        let areaArr = this.user.emdAreaName.split(' ');
        let areaSido = areaArr[0];
        let areaSigungu = areaArr[1];
        console.log('fetchPromotionView');
        console.log(areaArr);
        console.log(areaSido);
        console.log(areaSigungu);
        this.ktPromotionView = promotionCfg.getSidoCheck('KT', areaSido);

        let sidoCheck = promotionCfg.getSidoCheck('HELLO', areaSido);
        if (sidoCheck) {
          this.helloPromotionView = promotionCfg.getSigungu(
            'HELLO',
            areaSido,
            areaSigungu,
          );
        } else {
          this.helloPromotionView = false;
        }
      }
    },
    goPromotion(name, type) {
      this.$router.push({
        name: name,
        params: { type: type },
      });
    },
    setPromotionBnrView(place, type, telecom = '') {
      if (this.ktPromotionView && (telecom == '' || telecom == 'KT')) {
        // 노출 이벤트
        const params = {
          company: 'KT',
          campaign: 'PROMOTION',
          place: place,
          type: type,
        };
        this[bannerTypes.CLICK_VIEW_BANNER](params);
      }

      if (this.helloPromotionView && (telecom == '' || telecom == 'HELLO')) {
        // 노출 이벤트
        const params = {
          company: 'HELLO',
          campaign: 'PROMOTION_1',
          place: place,
          type: type,
        };
        this[bannerTypes.CLICK_VIEW_BANNER](params);
      }
    },
    async setBnr() {
      let mainSlideLeng = this.mainSlide.length;

      if (!this.ktPromotionView) {
        // 메인 중간 배너 셋팅
        let index = 0;
        for (let i = 0; i < mainSlideLeng; i++) {
          console.log(i);
          if (this.mainSlide[i].telecom == 'KT') {
            index = i;
            break;
          }
        }
        this.mainSlide.splice(index, 1);
      }

      if (!this.helloPromotionView) {
        // 메인 중간 배너 셋팅
        let index = 0;
        for (let i = 0; i < mainSlideLeng; i++) {
          console.log(i);
          if (this.mainSlide[i].telecom == 'HELLO') {
            index = i;
            break;
          }
        }
        this.mainSlide.splice(index, 1);
      }
    },
  },
};
</script>
